import * as React from 'react';

export default class MaliciousFile extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
        <svg className={this.props.className} style={{stroke:"white"}} xmlnsXlink="http://www.w3.org/2000/xlink">
        <path d="M11.8034 6.79631V9.55521L9.92981 7.81748L6.50035 10.2839L4.44858 7.81051L2 10.1977V2.36841H8.68563" stroke="white" strokeLinejoin="round"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M2 12.6368V15H11.8034L11.7676 11.9263L10.0251 10.2736L6.48421 12.9429L4.22805 10.2839L2 12.6368Z" stroke="white" strokeLinejoin="round"/>
        <circle cx="11.8684" cy="3.55263" r="3.05263" stroke="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M12.292 1.57581L12.1451 4.39614H11.4797L11.3328 1.57581H12.292ZM12.3524 5.2506C12.3524 5.44779 12.1019 5.62107 11.8081 5.62107C11.5143 5.62107 11.281 5.44779 11.281 5.2506C11.281 5.04744 11.5143 4.88013 11.8081 4.88013C12.1019 4.88013 12.3524 5.04744 12.3524 5.2506Z" fill="white"/>
        </svg>        
    )
  }
}
